import axios from "axios";
import Config from "./Config";

const { API_BASE_URL } = Config;

const headers = {
  "Content-Type": "application/json",
};

// ---------------------------FAQ ------------------------
// =========================Get All FAQ=========================
export const getAllFAQ = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/faq`, {
      headers,
    });

    if (response.data.status === true) {
      return response.data;
    } else {
      throw new Error(response.data.message || "API returned an error");
    }
  } catch (error) {
    console.error(
      "Error fetching board data:",
      error.response || error.message || error
    );
    throw error;
  }
};
